import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Model } from './Model';
import styles from './Swiper.scss';

class Swiper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modelState: {},
        };

        this.onModelChange = this.onModelChange.bind(this);
    }

    componentWillMount() {
        this._model =
            this.props.model ||
            new Model({
                itemsPerPage: this.props.itemsPerPage,
                itemCount: React.Children.count(this.props.children),
                onPageChange: this.props.onPageChange,
                startingPage: this.props.startingPage,
            });
    }

    componentDidMount() {
        // Pass the `el` to the view-model
        if (this._refList) {
            this._model.onMount(this._refList.parentElement);
            // Force a re-render if the model changes.
            this._model.addChangeListener(this.onModelChange);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { shouldCategoryTilesUpdate } = this.props;
        if (shouldCategoryTilesUpdate) {
            const itemCount = React.Children.count(nextProps.children);
            const itemsPerPage = nextProps.itemsPerPage;
            this._model._setPage(0);
            this._model.updateItemCount(itemCount, itemsPerPage);
        }
    }

    componentWillUnmount() {
        // Do any view-model cleanup.
        this._model.destroy();
        this._model.removeChangeListener(this.onModelChange);
    }

    onModelChange(modelState) {
        this.setState({ modelState });
    }

    enableSwipe() {
        this._model.enableSwipe();
    }

    disableSwipe() {
        this._model.disableSwipe();
    }

    /**
     * Wraps the passed in children in an `li` so we can apply additional styles to the items.
     * @return {Array}
     */
    _getChildren() {
        return React.Children.map(this.props.children, (child, i) => {
            const { item } = this.props.classNames;
            const style = {};
            const itemClass = classnames({
                [styles.item]: true,
                [item]: item,
            });

            // Get any item styles specified by the view-model.
            this._model.transformItemStyle(style, i);

            return (
                <li style={style} className={itemClass} data-tn={`carousel-item-${i}`}>
                    {child}
                </li>
            );
        });
    }

    render() {
        const { wrapper, list } = this.props.classNames;
        const style = {};
        const wrapperClass = classnames({
            [styles.wrapper]: true,
            [wrapper]: wrapper,
        });
        const listClass = classnames({
            [styles.list]: true,
            [list]: list,
        });

        // Get any styles specified by the view-model.
        this._model.transformListStyle(style);

        return (
            <div className={wrapperClass}>
                <ul
                    ref={c => {
                        this._refList = c;
                    }}
                    style={style}
                    className={listClass}
                >
                    {this._getChildren()}
                </ul>
            </div>
        );
    }
}

Swiper.propTypes = {
    model: PropTypes.object,
    onPageChange: PropTypes.func,
    startingPage: PropTypes.number,
    itemsPerPage: PropTypes.number,
    classNames: PropTypes.object,
    children: PropTypes.node,
    shouldCategoryTilesUpdate: PropTypes.bool,
};

Swiper.defaultProps = {
    itemsPerPage: 1,
    onPageChange: () => {},
    startingPage: 0,
    classNames: {},
};

export { Swiper };
